import React, { useEffect, useCallback} from 'react';

import styles from "./GameItem.module.css";
import RouterMgr from "@/Core/RouterMgr";
import Image from "next/image";
import {useSearchParams} from "next/navigation";
import {GameEntries} from "@/app/(pages)/home/homeData";
import {FontIcon} from "@/app/_components";
// import {useUser} from "@/app/context/UserContext";
import BigTips from "@/Master/BigTips";
import {useAppSelector} from "@/app/storeHooks";
import {selectUserInfo} from "@/app/userSlice";
import FrameOrientMgr from "@/Master/FrameOrient/FrameOrientMgr";

interface GameItemProps {
    data: GameEntries;
    // key:number;
}

const GameItem: React.FC<GameItemProps> = (props) => {
    const {data} = props;
    const {gameId, name, openVipLevel, preVipLevel,defaultDirection} = data;
    const searchParams = useSearchParams()
    const userInfo  = useAppSelector(selectUserInfo);

    // 点击外部区域关闭提示框
    useEffect(() => {

    }, []);

    const onEnterGame = () => {
        if (userInfo.vipLevel >= openVipLevel){
            RouterMgr.push(`/game?${createQueryString('game', gameId + '')}`);
            FrameOrientMgr.setGameDirection(defaultDirection);
        }else {
            BigTips.showMsg(`Reach VIP level ${openVipLevel} to unlock.`);
        }
    }

    const createQueryString = useCallback(
        (name: string, value: string) => {
            const params = new URLSearchParams(searchParams.toString())
            params.set(name, value)
            return params.toString()
        },
        [searchParams]
    )

    return (
        <>
            {
                <div className={`${styles.item} btn`} onClick={onEnterGame}>
                    <Image
                        src={`/img/home/icon/game_${gameId}.webp`}
                        alt={`game_${gameId}`}
                        fill // 使用 fill 属性让图片填满容器
                        style={{objectFit: 'cover'}}
                        loading="lazy"
                        placeholder={'blur'}
                        blurDataURL="/loading.webp"
                    >
                    </Image>

                    {userInfo.vipLevel < openVipLevel && (
                        <div className={styles.mask}>
                            {/*<h1 style={{color: '#fff'}}>{gameId}-{data.smallSort}-l:{user.baseInfo.vipLevel}</h1>*/}
                            <FontIcon icon="s-lock" className={styles.lock}/>
                        </div>
                    )}
                </div>
            }
        </>

    )
};

export default GameItem;
